// Nuvian · barre d'achat collante : en bas sur mobile, sous l'en-tête collant dès 990 px (PLAN3 Y-5).
customElements.get('nuvian-sticky-atc') || customElements.define('nuvian-sticky-atc', class extends HTMLElement {
  connectedCallback() {
    this.info = document.querySelector('product-info[id^="MainProduct-"]');
    this.form = this.info?.querySelector('form[id^="product-form-"][data-type="add-to-cart-form"]');
    this.button = this.querySelector('[data-satc-button]');
    if (!this.info || !this.form || !this.button) return;
    this.sectionId = this.info.dataset.section;
    this.button.setAttribute('form', this.form.id);
    this.button.addEventListener('click', (e) => this.onClick(e));
    this.state = { past: false, footer: false, drawer: false };
    this.observeTarget();
    const footer = document.querySelector('.shopify-section-group-footer-group, footer');
    if (footer) (this.footerObs = new IntersectionObserver(([e]) => this.set('footer', e.isIntersecting))).observe(footer);
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      this.drawerObs = new MutationObserver(() => this.set('drawer', drawer.classList.contains('active')));
      this.drawerObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => this.onVariantChange(e));
    }
    (this.resizeObs = new ResizeObserver(() => document.body.style.setProperty('--nv-c-satc-h', `${this.offsetHeight}px`))).observe(this);
    this.bar = this.querySelector('[data-satc-progress]');
    this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.desk = matchMedia('(min-width: 990px)');
    this.header = document.querySelector('.section-header, sticky-header');
    this.onScroll = () => this.raf || (this.raf = requestAnimationFrame(() => this.tick()));
    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.onScroll, { passive: true });
    this.tick();
  }
  disconnectedCallback() {
    [this.mainObs, this.footerObs, this.drawerObs, this.resizeObs].forEach((o) => o?.disconnect());
    this.unsub?.();
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.onScroll);
    document.body.classList.remove('nv-satc-active');
  }
  tick() {
    this.raf = 0;
    if (this.bar && !this.reduce) {
      const h = document.documentElement.scrollHeight - innerHeight;
      this.bar.style.transform = `scaleX(${h > 0 ? Math.min(1, scrollY / h) : 0})`;
    }
    if (this.desk.matches && this.header) {
      const b = Math.max(0, Math.round(this.header.getBoundingClientRect().bottom));
      if (b !== this.top) this.style.setProperty('--nv-satc-top', `${(this.top = b)}px`);
    }
  }
  set(k, v) {
    this.state[k] = v;
    this.render();
  }
  observeTarget() {
    this.mainObs?.disconnect();
    this.target = this.form.querySelector('[type="submit"]') || this.form;
    (this.mainObs = new IntersectionObserver(([e]) => this.set('past', !e.isIntersecting && e.boundingClientRect.top < 0))).observe(this.target);
  }
  render() {
    const { past, footer, drawer } = this.state;
    const shown = past && !footer;
    this.tick();
    this.classList.toggle('is-visible', shown && !drawer);
    document.body.classList.toggle('nv-satc-active', shown);
    if (shown) {
      this.removeAttribute('inert');
      this.removeAttribute('aria-hidden');
    } else {
      if (this.contains(document.activeElement)) this.target?.focus?.({ preventScroll: true });
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
    }
  }
  onClick(e) {
    if (!this.needsChoice) return;
    e.preventDefault();
    const picker = this.info.querySelector('variant-selects') || this.info;
    picker.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'center' });
    picker.querySelector('input:checked, select, input')?.focus({ preventScroll: true });
  }
  onVariantChange({ data }) {
    if (!data || data.sectionId !== this.sectionId) return;
    if (!this.target?.isConnected) {
      this.form = document.getElementById(this.form.id) || this.form;
      this.button.setAttribute('form', this.form.id);
      this.observeTarget();
    }
    const v = data.variant;
    const q = (s) => this.querySelector(s);
    if (q('[data-satc-variant]')) q('[data-satc-variant]').textContent = v ? v.title : '';
    const src = data.html?.getElementById?.(`price-${this.sectionId}`);
    const priceEl = q('[data-satc-price]');
    if (src && priceEl) this.updatePrice(src, priceEl);
    if (priceEl) priceEl.hidden = !v;
    this.needsChoice = !v;
    const ok = Boolean(v && v.available);
    this.button.disabled = Boolean(v) && !ok;
    this.button.type = v ? 'submit' : 'button';
    const d = this.dataset;
    if (q('[data-satc-label]')) q('[data-satc-label]').textContent = !v ? d.choose : ok ? d.label : d.soldOut;
    if (v?.featured_media) this.updateThumb(v.featured_media.id);
  }
  updateThumb(id) {
    const img = this.querySelector('[data-satc-thumb] img.nv-stage__img');
    const from = this.info.querySelector(`[data-media-id="${this.sectionId}-${id}"] img`);
    const url = from && (from.currentSrc || from.src);
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.src = url;
  }
  updatePrice(src, dest) {
    const p = src.querySelector('.price');
    if (!p) return;
    const t = (s) => src.querySelector(s)?.textContent.trim() || '';
    const sale = p.classList.contains('price--on-sale');
    const c = sale ? t('.price__sale s.price-item--regular') : '';
    const sr = (x) => `<span class="visually-hidden">${x || ''}</span>`;
    const d = this.dataset;
    dest.innerHTML = (c ? `<s class="nv-muted">${sr(d.regularLabel)}${c}</s> ${sr(d.saleLabel)}` : '') + (sale ? t('.price__sale .price-item--last') : t('.price__regular .price-item--regular'));
  }
});
